import { api as globalApi } from "app/slice";
import { api as loginApi } from "app/pages/Customer/Auth/Login/slice";
import { api as dashboardApi } from "app/pages/Customer/MyAccount/Dashboard/slice";
import { api as digitalSecurityCurrentAndUpgradePlansApi } from "app/pages/Customer/MyAccount/Dashboard/slice/digitalSecurityCurrentAndUpgradePlans";
import { api as simServiceApi } from "app/pages/Customer/MyAccount/SimService/slice";
import { api as paymentHistoryApi } from "app/pages/Customer/MyAccount/PaymentHistory/slice";
import { api as quickRechargeApi } from "app/pages/Customer/Auth/QuickRecharge/slice";
import { api as forgotPasswordApi } from "app/pages/Customer/Auth/ForgotPassword/slice";
import { api as digitalSecurityPlansApi } from "app/pages/Customer/Landing/DigitalSecurity/slice";
import { api as manageProfileApi } from "app/pages/Customer/MyAccount/ManageProfile/slice";
import { api as submitTickerApi } from "app/pages/Customer/Support/SubmitTicket/slice";
import { api as manageCardsApi } from "app/pages/Customer/MyAccount/ManageCards/slice";
import { api as fixedPhoneApi } from "app/pages/Customer/FixedPhone/slice";
import { api as activationApi } from "app/pages/Customer/Activation/slice";

export const rtkQueryMiddleware = [
  globalApi.middleware,
  loginApi.middleware,
  dashboardApi.middleware,
  digitalSecurityCurrentAndUpgradePlansApi.middleware,
  simServiceApi.middleware,
  paymentHistoryApi.middleware,
  quickRechargeApi.middleware,
  forgotPasswordApi.middleware,
  digitalSecurityPlansApi.middleware,
  manageProfileApi.middleware,
  submitTickerApi.middleware,
  fixedPhoneApi.middleware,
  manageCardsApi.middleware,
  activationApi.middleware,
];
